var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5817 0 0 3.5817 0 8C0 9.421 0.3816 10.75 1.0312 11.906C1.1391 12.098 1.2522 12.287 1.375 12.469L8 24L14.625 12.469C14.727 12.318 14.815 12.158 14.906 12L14.969 11.906C15.618 10.75 16 9.421 16 8C16 3.5817 12.418 0 8 0V0ZM8 4C10.209 4 12 5.7909 12 8C12 10.209 10.209 12 8 12C5.7909 12 4 10.209 4 8C4 5.7909 5.7909 4 8 4Z",
    fill: "#E74C3C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.7f0d6bf9.svg";
export { ForwardRef as ReactComponent };